/**
 * Backward-compat shim for `window.rml.hooks`.
 * The registry was removed; cross-plugin integration uses `RML/*` document events.
 */ const hooks = {
    register () {
        return hooks;
    },
    deregister () {
        return hooks;
    },
    call () {
        return hooks;
    },
    exists () {
        return false;
    }
};
export { hooks };
